import React from 'react'
import { useAppSelector } from '../../../Redux/store';
import { useGetTalentQuery } from '../../../Redux/api/talentApi';
import { skipToken } from '@reduxjs/toolkit/query';
import { Grid, Typography } from '@mui/material';
import { KaziCard } from '../../../Shared Components/Kazi/Cards/KaziCard';
import { AccountCircleOutlined } from '@mui/icons-material';
import { useGetManyJobsQuery } from '../../../Redux/api/jobApi';
import { KaziJobCard } from '../../../Shared Components/Kazi/Cards/KaziJobCard';
import { IMarketplaceJob } from '../../../Types/Job';

interface ITalentBookmarksProps {
    jobs?: IMarketplaceJob[]
}
export const TalentBookmarks = ( { jobs }: ITalentBookmarksProps ) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid display={'flex'} flexDirection={'column'}>
            <Typography variant='lora-headline-small'>Bookmarked jobs</Typography>
            <Grid display={'grid'} gridTemplateColumns={'repeat(3, 388px)'} marginTop={3} columnGap={4}>
                
                {
                    jobs?.map( (j, idx) => (
                        <Grid key={`${j.title}-${idx}`}>
                            <KaziJobCard 
                                job={j}
                            />
                        </Grid>
                    ))
                }
            </Grid>
        </Grid>
    )
}